/**
 * Applique une stratégie de révision depuis le dashboard (domaine / sous-domaine / granular)
 * et notifie MobileQCM pour recharger un QCM filtré.
 */
import { DEFAULT_REVISION_STRATEGY, saveRevisionStrategyToStorage } from './qcmInitialLoad';
import { aggregateMakeupConceptsByTriplet } from './makeupSessionStorage';

export const DASHBOARD_REVISION_EVENT = 'dashboard_revision_apply';

/** @typedef {'qcm' | 'flashcard'} DashboardStudyMode */

/**
 * @param {string} userId
 * @param {object} opts
 * @param {'manual_domain'|'manual_task'|'weakness_granular'} opts.filterType
 * @param {string[]} [opts.domainSelection]
 * @param {string[]} [opts.taskSelection]
 * @param {string[]} [opts.granularKeys]
 * @param {DashboardStudyMode} [opts.studyMode]
 */
export function applyDashboardRevisionStrategy(userId, examId, sessionId, opts) {
    const uid = userId || 'anonymous_user';
    const {
        filterType,
        domainSelection = [],
        taskSelection = [],
        granularKeys = [],
        studyMode = 'qcm',
    } = opts;

    const next = {
        ...DEFAULT_REVISION_STRATEGY,
        filterType,
        domainSelection: [...domainSelection],
        taskSelection: [...taskSelection],
        granularKeys: [...granularKeys],
        studyMode,
        _fromDashboard: true,
    };

    try {
        saveRevisionStrategyToStorage(uid, examId, sessionId, next);
    } catch (e) {
        console.warn('dashboardRevisionBridge: localStorage failed', e);
    }

    window.dispatchEvent(
        new CustomEvent(DASHBOARD_REVISION_EVENT, {
            detail: { strategy: next, studyMode },
        })
    );
}

/**
 * Trouve la clé granular (triplet make-up) correspondant à keywords_key du dashboard.
 * @param {string} userId
 * @param {string} keywordsKey — ex. "foo|bar|baz"
 * @returns {string[]}
 */
export function granularKeysForKeywordRow(userId, keywordsKey) {
    if (!keywordsKey || typeof keywordsKey !== 'string') return [];
    const concepts = aggregateMakeupConceptsByTriplet(userId);
    const exact = concepts.find((c) => c.key === keywordsKey);
    if (exact) return [exact.key];
    const k = keywordsKey.trim().toLowerCase();
    const loose = concepts.find(
        (c) => c.key === keywordsKey || String(c.key).toLowerCase() === k
    );
    if (loose) return [loose.key];
    return [];
}
